
import React, { Component } from 'react';
import { SHr, SNavigation, SNotification, SPopup, STheme, SView } from 'servisofts-component2';
// import Model from '../../../Model';
import MDL from '../../../MDL';
import Input from '../../../Components/Input';
import { StyleSheet } from 'react-native';
import PButtom from '../../../Components/PButtom';
// import CryptoJS from 'crypto-js';

export default class SectionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    submit() {
        this.form.submit();
    }
    inputRefs: { [key: string]: Input } = {};
    render() {
        return (
            <SView col={"xs-12"} center>
                <Input
                    ref={(ref) => this.inputRefs["dni"] = ref}
                    placeholder="Ingresa tu DNI o CIF"
                    // placeholder="Ingresa tu DNI"
                    required
                    style={styles.input}
                    // defaultValue='18536035J'
                />
                <SHr />
                <Input
                    ref={(ref) => this.inputRefs["matricula"] = ref}
                    // type="password"
                    required
                    placeholder="Ingresa tu Matrícula"
                    autoCapitalize="none"
                    // defaultValue='1419-JVS'

                    style={styles.input}
                />
                <SHr height={35} />
                <PButtom fontSize={20} onPress={() => {
                    let data = {};
                    let vacio = false;



                    Object.keys(this.inputRefs).forEach(key => {
                        let input = this.inputRefs[key];
                        console.log("input", input);
                        // input.validar() ?? false;
                        if (!input.validar()) {
                            vacio = true;
                            SNotification.send({
                                title: "Error al iniciar sesión.",
                                body: "Debes completar todos los campos correctamente.",
                                color: STheme.color.danger,
                                time: 5000
                            })
                            // SPopup.alert("Por favor, completa todos los campos correctamente.");
                            return;
                        } else if (input) {
                            data[key] = input.getValue();
                        }
                    });


                    console.log("data", data);
                    if (!vacio) {
                        if (this.loading) return;
                        SNotification.send({
                            key: "login",
                            title: "Iniciando sesión",
                            type: "loading",
                            time: 3000
                            // color: STheme.color.primary,
                        })
                        this.loading = true;
                        MDL.usuario.loginChofer({
                            dni: data.dni,
                            matricula: data.matricula
                        }).then((resp) => {
                            console.log("resp", resp);
                            this.loading = false;
                            if (resp) {
                                SNavigation.goBack();
                            } else {
                                SPopup.alert("Error en los datos");
                            }
                        }).catch((e) => {
                            console.error(e);
                            this.loading = false;
                            // SPopup.alert("Error en los datos");
                            SNotification.send({
                                key: "login",
                                title: "Error al iniciar sesión.",
                                body: e??"No se encontro el DNI",
                                color: STheme.color.danger,
                                time: 5000
                            })
                        })


                    }


                }}>INGRESAR</PButtom>

            </SView >
        );
    }
}
const styles = StyleSheet.create({
    input: {
        width: "100%",
        height: 60,
        fontSize: 18,
        letterSpacing: 1,
    },
});